import {useMutation} from "@tanstack/react-query";

import {updateSupplierMutationOptions} from "./update-supplier.mutation-options";

export function useUpdateSupplier(id: string) {
  return useMutation(updateSupplierMutationOptions(id));
}
